import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeModule } from '../home/home.module';
import { ConfigRoutingModule } from './config-routing.module';
import { CalendarComponent } from './calendar/calendar.component';
import { DataDictionaryComponent } from './data-dictionary/data-dictionary.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '../material/material.module';
import { CalendarUpdateComponent } from './calendar-update/calendar-update.component';
import { BannerConfigComponent } from './banner-config/banner-config.component';


@NgModule({
  declarations: [CalendarComponent, DataDictionaryComponent, CalendarUpdateComponent, BannerConfigComponent],
  imports: [
    CommonModule,
    ConfigRoutingModule,
    HomeModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class ConfigModule { }
